<script setup lang="ts">
import apiClient from '@/api/axios';
import { ApiRouten } from '@/api/routen';
import { useKundenbereichStore } from '@/stores/kundenbereichStore';
import { t, useI18n } from '@/utils/i18n';
import MarkdownIt from 'markdown-it';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import { computed, ref } from 'vue';

const kundenbereichStore = useKundenbereichStore();
const { locale, getLocaleMessage } = useI18n();

const markdown = new MarkdownIt();

// Wichtig: getLocaleMessage() statt t() verwenden.
// t() läuft durch den vue-i18n Message-Compiler und kann normales Markdown
// (z. B. E-Mail-Adressen mit @) zerstören.
// getLocaleMessage() liefert den Rohtext unverändert.
const rawMarkdown = computed(() => {
    const msg = getLocaleMessage(locale.value);

    return msg['[Nutzungsbedingungen]Nutzungsbedingungen'];
});

const agbZugestimmt = ref(false);
const formularAnzeigen = computed(() => !kundenbereichStore.einstellungen?.nutzungsbedingungenGelesen);
const isLoading = ref(false);

const akzeptieren = async () => {
    try {
        isLoading.value = true;
        // API-Aufruf zum Bestätigen der AGBs
        await apiClient.post(ApiRouten.KUNDENBEREICH.NUTZUNGSBEDINGUNGEN_BESTAETIGEN);

        // Flag im Store setzen
        kundenbereichStore.einstellungen.nutzungsbedingungenGelesen = true;

        // Keine Umleitung zur Dashboard-Seite, da wir bereits auf der aktuellen Route sind
        // Das AgbGate wird automatisch neu getriggert, da das Flag im Store gesetzt wurde
    } finally {
        isLoading.value = false;
    }
};
</script>

<template>
    <div>
        <div class="markdown" v-html="markdown.render(rawMarkdown)"></div>
        <div v-if="formularAnzeigen">
            <form @submit.prevent="akzeptieren" class="mt-4 space-y-4">
                <div class="flex items-center gap-2">
                    <Checkbox input-id="agbZustimmen" v-model="agbZugestimmt" :binary="true" />
                    <label for="agbZustimmen">
                        {{ t('[Nutzungsbedingungen]AllgemeineGeschaeftsbedingungenZustimmung') }}
                    </label>
                </div>
                <Button type="submit" 
                    :label="t('[Nutzungsbedingungen]Abschicken')" 
                    :loading="isLoading"
                    :disabled="!agbZugestimmt" />
            </form>
        </div>
    </div>
</template>
